import * as API from "../../api"
import * as ActionTypes from "../action-types";

import { message } from 'antd'
import {
  setLoadingGroup,
  unsetLoadingGroup,
} from "./style"

export const get_all_group_request = () => dispatch => {

  dispatch(setLoadingGroup())
  
      API.getAllGroup().then(info => {
        const { status, msg, groups } = info;
  
        if (status === 200) {
          dispatch(get_all_group_success(groups))
        } else {
          message.warning(msg);
        }
      }).finally(() => {
        dispatch(unsetLoadingGroup())
      })
}

const get_all_group_success = (group) => {
    return {
        type: ActionTypes.GROUP_GET_ALL,
        group
    };
}

export const create_group =
  ({coid, name, color}, cb) => (dispatch) => {

    API.createGroup({coid, name, color})
      .then((info) => {
        const { status, group, msg } = info;

        if (status === 200) {
          dispatch(create_group_success(group));
          message.success("Create Group Successfully");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb()
      });
  };

export const create_group_success = (group) => {
    return {
      type: ActionTypes.CREATE_GROUP,
      group,
    };
  };

export const get_group_thru_coid_request =
  (coid) => (dispatch) => {

    API.createGroup(coid)
      .then((info) => {
        const { status, group, msg } = info;

        if (status === 200) {
          dispatch(get_group_thru_coid_success(group));
        } else {
          message.warning(msg);
        }
    });
  };

export const get_group_thru_coid_success = (group) => {
    return {
      type: ActionTypes.GET_GROUP_BY_COID,
      group,
    };
  };

export const update_group_request =
  (items, cb) => (dispatch) => {

    API.updateGroup(items)
      .then((info) => {
        const { status, group, msg } = info;

        if (status === 200) {
          dispatch(update_group_success(group));
          message.success("Update Group Successfully");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb()
      });
  };

const update_group_success = (group) => {
    return {
        type: ActionTypes.UPDATE_GROUP,
        group
    };
}